<template>
  <div class="efocate-skeleton">
    <SkeletonAnimation>
      <div class="back"></div>
      <div class="block1"></div>
      <div class="block2"></div>
      <div class="cate-container">
        <div class="cate-list" v-for="index in 6" :key="index">
          <div class="block3"></div>
          <div class="block4"></div>
          <div class="block5">
            <div class="block6"></div>
            <div class="block7"></div>
          </div>
          <div class="block8"></div>
          <div class="block9"></div>
        </div>
      </div>
    </SkeletonAnimation>
  </div>
</template>
<script>
import SkeletonAnimation from '../../SkeletonAnimation';
export default {
  name: 'EfocateSkeletonH5',
  components: {
    SkeletonAnimation,
  },
};
</script>
<style lang="scss" scoped>
.efocate-skeleton {
  margin: 0 auto;
  padding: rem(20) 0;
}
.skeleton-bg {
  background: #e5e5eb;
}
.back {
  width: rem(200);
  height: rem(88);
  border-radius: rem(8);
  margin-bottom: rem(115);
  margin-left: rem(45);
}
.block1 {
  margin-left: rem(45);
  margin-bottom: rem(38);
  width: rem(373);
  height: rem(61);
  @extend .skeleton-bg;
  border-radius: rem(8);
}
.block2 {
  width: rem(172);
  height: rem(40);
  @extend .skeleton-bg;
  border-radius: rem(8);
  margin-left: rem(45);
  margin-bottom: rem(194);
}
.cate-container {
  margin: 0 rem(24);
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .cate-list {
    width: rem(341);
    height: rem(575);
    margin-bottom: rem(20);
    background: #ffffff;
    border-radius: rem(12);
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: rem(18);
    box-sizing: border-box;
  }
  .block3 {
    width: rem(305);
    height: rem(305);
    border-radius: rem(12);
    margin-bottom: rem(20);
    @extend .skeleton-bg;
  }
  .block4 {
    width: rem(301);
    height: rem(32);
    @extend .skeleton-bg;

    border-radius: rem(4);
    margin-bottom: rem(20);
  }
  .block5 {
    width: rem(300);
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .block6 {
    width: rem(159);
    height: rem(32);
    border-radius: rem(4);
    @extend .skeleton-bg;
  }
  .block7 {
    width: rem(124);
    height: rem(64);
    border-radius: rem(8);
    @extend .skeleton-bg;
  }
  .block8 {
    height: 1px;
    @extend .skeleton-bg;
    margin: rem(20) 0;
    width: rem(300);
  }
  .block9 {
    width: rem(305);
    height: rem(24);
    @extend .skeleton-bg;

    border-radius: rem(4);
  }
}
</style>
